<template>
    <client-page class="wrap wrap--sub">
        <!-- 서브비주얼 -->
        <sub-visual :visual="'마이페이지'"></sub-visual>
        <mypage-navigation></mypage-navigation>

        <section class="section">
            <v-container>
                <tit-primary sc="Operation status" tit="가동현황"> </tit-primary>

                <mes-dashboard-calendar v-model="date" v-bind="{ type, events, categories }" v-on="{ typeChange }" />
                <div class="mt-14 mt-lg-20">
                    <v-row class="mx-lg-n14">
                        <v-spacer class="d-none d-sm-block" />
                        <v-col cols="auto" v-for="item in categoriesWithColor" :key="item.category" class="d-flex align-center pa-lg-14">
                            <span class="color d-block mr-8 mr-lg-16" :style="'background-color: '+item.color"></span>
                            <span class="page-text--sm color-grey">{{item.category}}</span>
                        </v-col>
                    </v-row>
                </div>
            </v-container>
        </section>
    </client-page>
</template>

<script>
import api from "@/api";
import dayjs from "dayjs";

import SubVisual from "@/components/client/sub/sub-visual.vue";
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import TitPrimary from "@/components/client/dumb/tit-primary.vue";
import MypageNavigation from "@/components/client/mypage-navigation.vue";
import MesDashboardCalendar from "@/components/client/mypage/mes/mes-dashboard-calendar.vue";

let CATEGORIES = {
    ["line-1"]: { category: "전자제조실장1라인", color: "#109264" },
    ["line-2"]: { category: "전자제조실장2라인", color: "#ff9000" },
    ["line-3"]: { category: "보드조립라인", color: "#db469a" },
};
let categories = Object.values(CATEGORIES).map(({ category }) => category);
let categoriesWithColor = Object.values(CATEGORIES)

export default {
    components: {
        SubVisual,
        ClientPage,
        TitPrimary,
        MypageNavigation,
        MesDashboardCalendar,
    },
    data: () => ({
        date: Date.now().toDate(),
        type: "month",
        schedules: [],
        categories,
        categoriesWithColor
    }),
    computed: {
        dates() {
            let start = dayjs(this.date).startOf("month");
            let end = dayjs(this.date).endOf("month");
            return [start, end].map((date) => date.toISOString());
        },
        events() {
            return this.schedules.map(({ code, date, modelName, clientName, ...item }) => {
                let categoryData = CATEGORIES[code];
                let dates = { start: date, end: date };
                let name = `[${clientName}] ${modelName}`;
                return { ...dates, name, ...item, ...categoryData };
            });
        },
    },
    mounted() {
        this.search();
    },
    watch: {
        date() {
            this.search();
        },
    },
    methods: {
        typeChange(type) {
            this.type = type;
        },
        async search() {
            this.loading = true;
            try {
                let { dates } = this;
                this.schedules = (await api.v1.me.mes.schedules.gets({ params: { dates } }))?.schedules;
            } catch (error) {
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style scoped>
.color{
    width: 6px;
    height: 6px;
    border-radius: 50%;
}

@media (min-width:576px){
}
@media (min-width:768px){
}
@media (min-width:1024px){
    .color{
        width: 14px;
        height: 14px;
    }
}
@media (min-width:1200px){
}

</style>
